import { styled } from "styled-components";

import { breakpoints } from "common/styles";
import { useElementIsLoaded } from "common/utilities";
import { useMemoisedSelector, useSelector } from "common/utilities/react-redux";
import { useTranslate } from "common/utilities/useTranslate";
import { FollowingTopics } from "domains/discover/components/FollowingTopics";
import { TopicSlider } from "domains/landing/topics/TopicSlider";
import { getCanFollowTopic } from "entities/permissions/selectors";
import { createTopicsSelector, getHighlightedTopicsIds } from "entities/topics/selectors";

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3rem;
  justify-content: center;
  padding: 4rem 2rem 2rem;
  max-width: 1600px;
  margin: 0 auto;

  @media ${breakpoints.medium} {
    padding: 4rem;
  }
`;

export const HighlightsSections = () => {
  const { isLoaded, elementRef } = useElementIsLoaded(0.5);
  const highlights = useMemoisedSelector(getHighlightedTopicsIds, createTopicsSelector);
  const canFollowTopic = useSelector(getCanFollowTopic);
  const translate = useTranslate();

  return (
    <StyledContainer ref={elementRef}>
      <TopicSlider
        title={translate("app.discover.topics.highlights.title")}
        message={translate("app.discover_topics.highlights")}
        topics={highlights}
        isLoaded={isLoaded}
      />
      {canFollowTopic && (
        <div>
          <FollowingTopics />
        </div>
      )}
    </StyledContainer>
  );
};
